__webpack_require__.p = "/mobile-app-comparison/";